import {
  browserTracingIntegration,
  init,
  makeFetchTransport,
  makeMultiplexedTransport,
  moduleMetadataIntegration,
  replayIntegration,
} from '@sentry/react';

import {
  APP_LK_BRANCH,
  APP_COMMIT,
  APP_LK_STAGE,
  APP_SENTRY_ENABLED,
  APP_SENTRY_URL,
} from ':constants';

type RouteTo = {
  dsn: string;
  release: string;
};

const EXTRA_KEY = 'sentryMF';

const transport = makeMultiplexedTransport(makeFetchTransport, args => {
  const event = args.getEvent();

  if (
    event?.extra &&
    EXTRA_KEY in event.extra &&
    Array.isArray(event.extra[EXTRA_KEY])
  ) {
    return event.extra[EXTRA_KEY];
  }
  return [];
});

if (APP_SENTRY_ENABLED) {
  init({
    dsn: APP_SENTRY_URL,
    environment: APP_LK_STAGE,
    release: `${APP_LK_BRANCH}_${APP_COMMIT.slice(0, 8)}`,
    integrations: [
      browserTracingIntegration(),
      replayIntegration(),
      moduleMetadataIntegration(),
    ],
    transport,
    beforeSend: event => {
      if (event.exception?.values?.[0].stacktrace?.frames) {
        const { frames } = event.exception.values[0].stacktrace;
        const routeTo: RouteTo | undefined = frames
          .filter(({ module_metadata }) => module_metadata?.dsn)
          .map(({ module_metadata }) => module_metadata)
          .at(-1);

        if (routeTo) {
          event.extra = {
            ...event.extra,
            [EXTRA_KEY]: [routeTo],
          };
        }
      }

      return event;
    },
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
